var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow_up","data-name":"arrow up","transform":"translate(0)"},[React.createElement("rect",{"id":"Rectangle_868","data-name":"Rectangle 868","width":"32","height":"32","transform":"translate(32 32) rotate(180)","fill":"#fff","opacity":"0","key":0}),React.createElement("path",{"id":"Path_2376","data-name":"Path 2376","d":"M-14348.051,238.107l3.585-3.474H-14372v-1.264h27.533l-3.585-3.474.922-.894,5.13,4.974-5.13,5.026Z","transform":"translate(-218.001 -14340.999) rotate(-90)","fill":"#000f10","key":1})]));
}

ArrowUp.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
